import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { makeStyles } from '@mui/styles';
import colors from '../colors'



const HorizontalLabelPositionBelowStepper = (props) => {

  const steps = [...props.steps];
  const useStyles = makeStyles(() => ({
    root: {
      "& .Mui-active": {color: colors.orange},
      "& .Mui-active .MuiStepIcon-text": { fill: "white" },
      "& .Mui-completed .MuiStepIcon-root": { color: "#EF7A30" },
      "& .MuiStepIcon-text": { fill: "black" },
      "& .MuiStepLabel-label": { color: "white" },
      "& .Mui-disabled .MuiStepIcon-root": { color:'white' },
      "& .MuiStepConnector-line ": {backgroundColor: colors.darkBlue, height:'2.5px' }
    }
  }));

  const classes = useStyles()

  return (
    <Box sx={{ width: '50%', '@media (max-width: 899px)' : {width:'90%'} }}>
      <Stepper className={classes.root} activeStep={props.currentStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

export default HorizontalLabelPositionBelowStepper